Ext.define('SA.HistogramRequest', {
    statics: {
        create(modelState) {
            if (modelState.geoUnits.selected === null) {
                return new SA.HistogramNoGeoUnitRequest();
            }

            return new SA.HistogramRequest(modelState);
        }
    },

    constructor(modelState) {
        this.params = {
            binSize: modelState.binSize.size,
            attribute: modelState.attributes.selected.id,
            geographicUnit: modelState.geoUnits.selected,
            locationItem: SA.data.LocationsCache.toLocationItem(modelState.locations.selected.id)
        };

        this.hash = JSON.stringify({...this.params, comboConstituents: modelState.locations.selected.comboConstituents});
    },

    dispatch() {
        var getResult = this.getResult.bind(this),
            request = SA.Ajax.request({
                resource: 'data/histogram',
                data: this.params,
                success: this.onSuccess.bind(this),
                failure: this.onFailure.bind(this)
            });

        this.resultPromise = request.then(getResult, getResult);

        return this.resultPromise;
    },

    equals(request) {
        return !!request && request.getHash() === this.getHash();
    },

    getHash() {
        return this.hash;
    },

    getResult() {
        return this.result;
    },

    getResultPromise() {
        return this.resultPromise;
    },

    isPending() {
        return typeof this.result === 'undefined';
    },

    onFailure(error) {
        if (!error.hasType(['TooFewBinsException', 'TooManyBinsException', 'InsufficientDataForHistogramException'])) {
            error.flagUnexpected();
        }

        this.result = new SA.HistogramResult({noDataReason: error.getType()});
    },

    onSuccess(results) {
        this.result = new SA.HistogramResult({data: new SA.HistogramData(results)});
    }
});